<sbnb-thermostat-setup-success-wrapper>
  <h2>🎉 Your thermostat is now synced to your reservations!</h2>

  <p>We've set up three presets to automatically manage your property temperatures:</p>

  <div class="grid grid-cols-[1fr_1fr_1fr] gap-4">
    <div class="preset">
      <sbnb-icon [size]="52" icon="occupied"></sbnb-icon>
      <h3>Occupied</h3>
      <span>Keeps your property comfortable for guests from check-in to check-out</span>
    </div>

    <div class="preset">
      <sbnb-icon [size]="52" icon="unoccupied"></sbnb-icon>
      <h3>Unoccupied</h3>
      <span>Saves energy costs after check-out while staying ready for the next booking</span>
    </div>

    <div class="preset">
      <sbnb-icon [size]="52" icon="long-term-unoccupied"></sbnb-icon>
      <h3>Long-term Unoccupied</h3>
      <span>Maximizes energy savings during extended vacancies</span>
    </div>
  </div>

  <p>Let's customize these presets to suite your needs.</p>

  <sbnb-button class="justify-self-end" (click)="continue()">Continue</sbnb-button>
</sbnb-thermostat-setup-success-wrapper>
